export default "__VITE_ASSET__VxK2f_Co__"